module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAKAQMAAABR1Za6AAAABlBMVEX///////9VfPVsAAAAAXRSTlMAQObYZgAAACZJREFUCB1jYGRgYG5gYD/AwP+AQe4Dg00FQ4UNwwc5hgd8DA4sAF9CBvFDyYD3AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./web/img/backtop.png
// module id = 753
// module chunks = 0